import { FC } from "preact/compat";
import { useEffect } from "preact/hooks";
import { isSameDay } from "date-fns";
import { Track } from "~/core";
import { useApp } from "~/core/store";
import { useForceRender } from "~/hooks";
import { leadZero } from "~/utils";
import { TileTotalTodayProps } from "./interfaces";

const EACH_SECOND = 1000;

const getTotalSeconds = (tracks: Track[], now: Date) => {
    let seconds = 0;

    for (const track of tracks) {
        if (track.stop) {
            seconds += Math.floor((track.stop - track.start) / 1000);
        } else {
            seconds += Math.floor((now.getTime() - track.start) / 1000);
        }
    }

    return seconds;
};

const TileTotalToday: FC<TileTotalTodayProps> = ({ tile }) => {
    const {
        tracker: { activeTile },
        api: { time },
    } = useApp();
    const forceRender = useForceRender();
    const today = new Date();
    const todayTracks = time.track.tracks.value.filter(
        (t) => t.group?.id === tile.id && isSameDay(t.start, today),
    );
    const totalSeconds = getTotalSeconds(todayTracks, today);
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;

    useEffect(() => {
        const isActive = activeTile.value?.id === tile.id;

        if (!isActive) {
            return;
        }

        const interval = setInterval(forceRender, EACH_SECOND);

        return () => clearInterval(interval);
    }, [activeTile.value, forceRender, tile]);

    return (
        <div className="font-bold tracking-wider">
            {leadZero(h)}:{leadZero(m)}:{leadZero(s)}
        </div>
    );
};

export default TileTotalToday;
